import { IconCopy, IconSend } from '@tabler/icons-react'
import { Button, Col, Input, InputNumber, Row, Space, message } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../../theme/ThemeProvider'
import API from '../../../../utils/api'
import { useToken } from '../../../hooks'
import { useFetcherSetting } from '../../../hooks/fetcher'
import { useTradeModalStore } from '../../../hooks/trade/modalStore'
import { useMyProfile } from '../../../hooks/user/myprofile'
import { API_URL } from 'app/constants/APIKEYS'

// SDK type declaration
declare global {
	interface Window {
	  SpuraSDK: {
		initialize: (clientId: string, options?: any) => {
		  setCallbacks: (callbacks: any) => void;
		};
	  };
	}
  }

const PGDeposit = ({ mobile = false }) => {
	const { textw, onTertiary, descBox, stroke } =
		useContext(ThemeContext).theme.COLORS
	const { isDarkMode } = useContext(ThemeContext)
	const { data: token } = useToken()
	const { data } = useFetcherSetting('GINFOD')
	const { data: cs1 } = useFetcherSetting('GCS1')
	const { data: cs2 } = useFetcherSetting('GCS2')
	const { data: bank1 } = useFetcherSetting('GBANK1')
	const { data: bank2 } = useFetcherSetting('GBANK2')
	const { data: bank3 } = useFetcherSetting('GBANK3')
	const [amount, setAmount] = useState<any>(0)
	const [name, setName] = useState('')
	const { data: modalStore, mutate: mutateModalStore } = useTradeModalStore()
	const [usdtPrice, setUsdtPrice] = useState<number>(0);
	const [spura, setSpura] = useState<any>(null);
	const { data: profile } = useMyProfile()

	useEffect(() => {
		getBithumbUSDTPrice();

	// 1분마다 USDT 가격 업데이트
    const interval = setInterval(getBithumbUSDTPrice, 60000);

    // Content-Security-Policy meta tag
    const meta = document.createElement('meta');
    meta.httpEquiv = 'Content-Security-Policy';
    meta.content = 'upgrade-insecure-requests';
    document.head.appendChild(meta);

    // SDK script load
	const script = document.createElement('script');
	script.src = 'https://sdk.supra-pay.com/v3/suprapay-sdk.js';
	// script.src = 'https://sdk.supra-pay.com/v3/suprapay-sdk-demo.js';
	script.async = true;
	script.setAttribute('data-spura-client-id', '3e69b3a18191');
	// script.setAttribute('data-spura-client-id', 'e3c88a918191');

	script.crossOrigin = 'anonymous';
	script.referrerPolicy = 'no-referrer';
	script.onload = initializeSpura;
	script.onerror = (e) => {
		console.error('Spura SDK load failed', e);
	};
	document.head.appendChild(script);

    return () => {
      clearInterval(interval);
      document.head.removeChild(script);
      document.head.removeChild(meta);
      
      // Supra-pay SDK로 인해 추가된 스타일 제거
      const styles = document.querySelectorAll('style');
      styles.forEach(style => {
        if (style.textContent?.includes('supra-pay') || style.textContent?.includes('spura')) {
          style.remove();
        }
      });
    };
	  }, []);

	  const initializeSpura = () => {
		if (window.SpuraSDK) {
			const spuraInstance = window.SpuraSDK.initialize('3e69b3a18191', {
			// const spuraInstance = window.SpuraSDK.initialize('e3c88a918191', {
				popupWidth: 500,
				popupHeight: 700,
			});
			// 콜백은 setCallbacks로 설정
			spuraInstance?.setCallbacks({
				onSuccess: (data) => {
					console.log('Payment Success:', data);
					// PG 결제 성공 시 입금 요청 처리
					if (data?.status === 'success') {
						// handleDepositRequest(data);
						if (mobile) {
							alert('결제가 완료되었습니다.');
						} else {
							message.success('결제가 완료되었습니다.');
						}
					} else {
						console.error('결제 성공 콜백이지만 상태가 success가 아님:', data);
						if (mobile) {
							alert('결제 처리 중 오류가 발생했습니다.');
						} else {
							message.error('결제 처리 중 오류가 발생했습니다.');
						}
					}
				},
				onError: (error) => {
					console.error('Payment Failed:', error);
					// if (mobile) {
					// 	alert('결제에 실패했습니다. 다시 시도해주세요.');
					// } else {
					// 	message.error('결제에 실패했습니다. 다시 시도해주세요.');
					// }
				},
				onCancel: (data) => {
					console.warn('Payment Cancelled:', data);
					if (mobile) {
						alert('결제가 취소되었습니다.');
					} else {
						message.info('결제가 취소되었습니다.');
					}
				},
			});
			setSpura(spuraInstance);
		}
	};

	const getBithumbUSDTPrice = async () => {
		try {
		  const response = await fetch('https://api.bithumb.com/public/ticker/USDT_KRW');
		  const data = await response.json();
		  
		  if(data.status === '0000') {
			setUsdtPrice(parseFloat(data.data.closing_price));
		  }
		} catch (error) {
		  console.error('Error fetching USDT price:', error);
		}
	  };

	  // PG 결제 성공 시 입금 요청 처리 함수
	  // const handleDepositRequest = async (paymentData: any) => {
	  //   try {
	  //     // 콜백 데이터에서 실제 결제 정보 추출
	  //     const { data: paymentInfo } = paymentData;
	  //     const actualAmount = Number(paymentInfo?.amount || amount); // 실제 결제된 금액
	  //     const usdtQty = Number(paymentInfo?.usdtqty || 0); // 실제 USDT 수량
	  //     const orderNo = paymentInfo?.orderno; // 주문번호
	  //     
	  //     console.log('결제 정보:', {
	  //       actualAmount,
	  //       usdtQty,
	  //       orderNo,
	  //       originalAmount: amount,
	  //       paymentData
	  //     });
	  //     
	  //     const response = await fetch(`${API_URL}/payment/request`, {
	  //       method: 'POST',
	  //       headers: {
	  //         'Content-Type': 'application/json',
	  //         'Authorization': `Bearer ${token}`
	  //       },
	  //       body: JSON.stringify({
	  //         request_type: "DEPOSIT",
	  //         amount: actualAmount, // 실제 결제된 금액 사용
	  //         data: {
	  //           bank_owner: profile?.bank_owner,
	  //           account_number: profile?.bank_account,
	  //           bank_name: profile?.bank_name,
	  //         }
	  //       })
	  //     });

	  //     const result = await response.json();
	  //     
	  //     if (result.success) {
	  //       console.log('입금 요청 생성 성공:', result);
	  //       if (mobile) {
	  //         alert(`입금신청이 완료되었습니다.\n결제금액: ${actualAmount.toLocaleString()}원\nUSDT: ${usdtQty}`);
	  //       } else {
	  //         message.success(`입금신청이 완료되었습니다. (결제금액: ${actualAmount.toLocaleString()}원, USDT: ${usdtQty})`);
	  //       }
	  //       // 모달 닫기
	  //       mutateModalStore({
	  //         ...modalStore,
	  //         gDeposit: false,
	  //       });
	  //     } else {
	  //       throw new Error(result.message || '입금 요청 처리에 실패했습니다.');
	  //     }
	  //   } catch (error) {
	  //     console.error('입금 요청 생성 실패:', error);
	  //     if (mobile) {
	  //       alert('입금 요청 처리에 실패했습니다. 고객센터에 문의해주세요.');
	  //     } else {
	  //       message.error('입금 요청 처리에 실패했습니다. 고객센터에 문의해주세요.');
	  //     }
	  //   }
	  // };

	  const handleBuyClick = () => {
		// 입금액 검증 - 10만원 미만이면 PG 모듈 실행 차단
		if (amount < 100000) {
			if (mobile) {
				alert('입금액은 10만원 이상이어야 합니다.');
			} else {
				message.error('입금액은 10만원 이상이어야 합니다.');
			}
			return;
		}

		// 입금액 검증 - 495만원 초과이면 PG 모듈 실행 차단
		if (amount > 4950000) {
			if (mobile) {
				alert('입금액은 495만원 이하여야 합니다.');
			} else {
				message.error('입금액은 495만원 이하여야 합니다.');
			}
			return;
		}

		// 계정 레벨 검증 - 일반회원(레벨 1)만 입금 가능
		if(profile?.level == 5 || profile?.level == 7 || profile?.level == -10){
			if (mobile) {
				alert('일반회원만 입금이 가능합니다');
			} else {
				message.error('일반회원만 입금이 가능합니다');
			}
			return;
		}

		if(profile?.level == 6){
			if (mobile) {
				alert('모의회원은 일반입금이 불가합니다');
			} else {
				message.error('모의회원은 일반입금이 불가합니다');
			}
			return;
		}

		// PG 결제 프로세스만 시작 (입금 요청은 결제 성공 콜백에서 처리)
		if (!window.SpuraSDK) {
		  console.warn('Spura SDK not loaded yet');
		  if (mobile) {
			alert('결제 시스템을 로딩 중입니다. 잠시 후 다시 시도해주세요.');
		  } else {
			message.warning('결제 시스템을 로딩 중입니다. 잠시 후 다시 시도해주세요.');
		  }
		  return;
		}
		
		if (!spura) {
		  initializeSpura();
		}
	  };


	return (
		<Space
			direction={mobile ? 'vertical' : 'horizontal'}
			size={'small'}
			style={{
				width: '100%',
				alignItems: mobile ? 'center' : 'flex-start',
			}}>
			<Space
				direction="vertical"
				style={{
					minWidth: mobile ? '100%' : 330,
					alignSelf: 'flex-start',
					height: '100%',
					width: '100%',
				}}
				size={'small'}>
				<Row
					align={'middle'}
					style={{
						background: onTertiary,
						color: textw,
						margin: '10px 0',
						padding: 5,
						width: '100%',
					}}>
					<Col span={24} style={{ textAlign: 'center' }}>
						입금액
					</Col>
				</Row>
				<Row align={'middle'}>
					<Col span={6}>신청금액</Col>
					<Col span={13}>
						<InputNumber
							value={amount}
							formatter={value =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')?.replace(/[^0-9,]/g, '')
							}
							parser={value => value!.replace(/\$\s?|(,*)/g, '')?.replace(/[^0-9]/g, '')}
							step={1000}
							onChange={e => setAmount(e)}
							style={{
								textAlign: 'right',
								width: '100%',
								flex: 1,
							}}
							readOnly={profile?.level !== 7}
						/>
					</Col>
					<Col span={1}>원</Col>
					<Col span={4}>
						<Button
							size="small"
							onClick={() => {
								setAmount(0)
							}}>
							재입력
						</Button>
					</Col>
				</Row>
				<Row align={'middle'}>
					<Col span={24}>
						<Space.Compact>
						{/* <Button
								size="small"
								onClick={() => {
									setAmount(amount + 100000000)
								}}>
								+1억
							</Button>
							<Button
								size="small"
								onClick={() => {
									setAmount(amount + 50000000)
								}}>
								+5000만
							</Button>
							<Button
								size="small"
								onClick={() => {
									setAmount(amount + 10000000)
								}}>
								+1000만
							</Button> */}
							<Button
								size="small"
								onClick={() => {
									setAmount(4950000)
								}}>
								최대
							</Button>
							<Button
								size="small"
								onClick={() => {
									setAmount(Math.min(amount + 1000000, 4950000))
								}}>
								+100만
							</Button>
							<Button
								size="small"
								onClick={() => {
									setAmount(Math.min(amount + 500000, 4950000))
								}}>
								+50만
							</Button>
							<Button
								size="small"
								onClick={() => {
									setAmount(Math.min(amount + 100000, 4950000))
								}}>
								+10만
							</Button>
							<Button
								size="small"
								onClick={() => {
									setAmount(Math.min(amount + 50000, 4950000))
								}}>
								+5만
							</Button>
							<Button
								size="small"
								onClick={() => {
									setAmount(Math.min(amount + 10000, 4950000))
								}}>
								+1만
							</Button>
							</Space.Compact>
					</Col>
				</Row>
				
				
				<Row style={{ marginTop: 10 }}>
					<Col span={24} style={{ textAlign: 'right' }}>
						<Button
							type="primary"
							icon={<IconSend size={14} />}
							{...(amount >= 100000 && amount <= 4950000 && profile?.level === 1 ? {
								'data-spura-type': 'buy',
								'data-spura-user-id': `${(window as any).BRAND_CONFIG?.REACT_APP_TITLE || process.env.REACT_APP_TITLE || ''}_${profile?.id || ''}`,
								'data-spura-user-name': `${profile?.fullname || ''}`,
								'data-spura-usdtqty': Math.floor(Number(amount) / usdtPrice) || 0,
								'data-spura-display': mobile ? 'popup' : 'modal'
							  } : {})}
							
							onClick={() => {
								handleBuyClick();	
							}}>
							입금신청
						</Button>
					</Col>
				</Row>
			</Space>
			{mobile ? (
				<div
					style={{
						width: '100%',
						minWidth: 330,
						height: 200,
						overflowY: 'auto',
						overflowX: 'hidden',
						border: '1px solid #cdcdcd',
						padding: 5,
						marginTop: 10,
						fontSize: 12,
						lineHeight: 1.1,
						whiteSpace: 'pre-wrap',
					}}>
					{data}
				</div>
			) : (
				<div
					style={{
						width: '100%',
						height: 540,
						minWidth: 527,
						overflowY: 'auto',
						overflowX: 'hidden',
						border: '1px solid #cdcdcd',
						padding: 5,
						marginTop: 10,
						whiteSpace: 'pre-wrap',
					}}>
					{data}
				</div>
			)}
		</Space>
	)
}

export default React.memo(PGDeposit)
